import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import CopyContent from '../common/CopyContent';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const OfferHasFlowsModal = ({ open, toggle, flows, offerId, onFlowCopy, isСopied }) => {
  const renderFlowsList = () => (
    <ul className="offer-has-flows-modal-list list-unstyled no-margin">
      {flows.map((flow) => {
        const { id, title, link, directLinkWithOutRedirect, directLinkLanding } = flow;
        return (
          <li className="offer-has-flows-modal-item" key={`offer-has-flows-modal-item-${id}`}>
            <a href={flow.link} target="_blank">
              {title}
            </a>
            <div className="d-flex align-items-center">
              <span className="mr-3">{isСopied === id && <Loader small />}</span>
              {directLinkLanding && (
                <CopyContent
                  className="offer-has-flows-modal-directlink mr-2"
                  content={directLinkLanding}
                  iconType="copy-3"
                  copyMessageId="flows.table.click-link"
                  tooltipMessageId="flows.table.direct-link.copy"
                  tooltipTargetId={`flow_direct_link_${id}`}
                />
              )}
              {directLinkWithOutRedirect && (
                <CopyContent
                  className="offer-has-flows-modal-directlink mr-2"
                  content={directLinkWithOutRedirect}
                  iconType="copy-3"
                  copyMessageId="flows.table.click-link"
                  tooltipMessageId="flows.table.direct-link.copy"
                  tooltipTargetId={`flow_direct_link_${id}`}
                />
              )}
              {/* {link && (
                <CopyContent
                  className="offer-has-flows-modal-link mr-2"
                  content={link}
                  iconType="link-3"
                  copyMessageId="flows.table.click-link"
                  tooltipMessageId="flows.table.click-link.copy"
                  tooltipTargetId={`flow_link_${id}`}
                />
              )} */}
              {!directLinkWithOutRedirect && !directLinkLanding ? (
                <>
                  <a
                    id={`copy_flow_button_${id}`}
                    className="offer-has-flows-modal-copy mr-2"
                    onClick={() => onFlowCopy(id, offerId)}
                    role="button"
                    aria-label="Copy Flow"
                  >
                    <SVG
                      src={`${STATIC_PATH}/img/action-icons/copy_flow.svg`}
                      height="20"
                      width="20"
                      cacheRequests
                    />
                  </a>
                  <UncontrolledTooltip
                    placement={'bottom'}
                    trigger="legacy hover"
                    target={`copy_flow_button_${id}`}
                    delay={250}
                  >
                    <FormattedMessage id="flows.table.copy_flow" defaultValue="Copy" />
                  </UncontrolledTooltip>
                </>
              ) : null}
              <Link to={`/tools/flows/${id}`} className="offer-has-flows-modal-settings">
                <SVG
                  src={`${STATIC_PATH}/img/action-icons/settings-icon.svg`}
                  height="20"
                  width="20"
                  cacheRequests
                />
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );

  return (
    <Modal
      backdrop="static"
      toggle={toggle}
      isOpen={open}
      centered
      className="offer-has-flows-modal"
    >
      <ModalHeader toggle={toggle}>
        <FormattedMessage
          id="offer.has-flow-modal.title"
          defaultMessage="You have already created flows for this offer."
        />
      </ModalHeader>

      <ModalBody>
        <FormattedMessage
          id="offer.has-flow-modal.text"
          defaultMessage="You can get links for the created flows or create a new one."
          tagName="p"
        />

        <p className="offer-has-flows-modal-subtitle">
          <FormattedMessage
            id="offer.has-flow-modal.flows_title"
            defaultMessage="Your flows:"
            tagName="span"
          />
        </p>

        {flows && flows.length > 0 && renderFlowsList()}
      </ModalBody>

      <ModalFooter>
        <Button tag={Link} to={`/tools/flows/create?offer=${offerId}`} color="primary">
          <FormattedMessage id="offer.has-flow-modal.button" defaultMessage="Create flow" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OfferHasFlowsModal;
